import React from 'react';
import { withUrlParams } from 'Utils/withUrlParams';
import { withRouter } from 'react-router-dom';
import Highlights from 'Components/Highlights';
import { Col, Row, Container } from 'Components/Grid';
import { getGivenBackground } from 'Utils/getColor';
import DefaultPage from 'Containers/DefaultPage';

const Landingpage = (props) => (
  <DefaultPage background={getGivenBackground('white')} deeplinkId={props.deeplinkId}>
    <Container>
      <Row align="center">
        <Col>
          <Highlights {...props} background={'white'} />
        </Col>
      </Row>
    </Container>
  </DefaultPage>
);

export default withRouter(withUrlParams(Landingpage));
